export default __webpack_public_path__ + "static/media/plus-icone.59cba0cf.svg";